"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointerEventAdapterManager = void 0;
var tslib_1 = require("tslib");
/**
 * The default adapter does a direct mapping from pointer events to mouse event handlers.
 */
var DefaultPointerEventAdapter = /** @class */ (function () {
    function DefaultPointerEventAdapter() {
    }
    // tslint:disable-next-line:max-line-length
    DefaultPointerEventAdapter.prototype.getHtmlAttributes = function (_a) {
        var disabled = _a.disabled, pointerClick = _a.pointerClick, pointerDoubleClick = _a.pointerDoubleClick, pointerDown = _a.pointerDown, pointerUp = _a.pointerUp;
        return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (pointerDoubleClick && { onDoubleClick: function (e) { if (!disabled) {
                pointerDoubleClick(e);
            } } })), (pointerDown && { onMouseDown: function (e) { if (!disabled) {
                pointerDown(e);
            } } })), (pointerUp && { onMouseUp: function (e) { if (!disabled) {
                pointerUp(e);
            } } })), (pointerClick && { onClick: function (e) { if (!disabled) {
                pointerClick(e);
            } } }));
    };
    return DefaultPointerEventAdapter;
}());
var PointerEventAdapterManager = /** @class */ (function () {
    function PointerEventAdapterManager() {
    }
    /**
     * Clients with custom pointer event systems should override the default factory
     */
    PointerEventAdapterManager.adapterFactory = function () { return new DefaultPointerEventAdapter(); };
    return PointerEventAdapterManager;
}());
exports.PointerEventAdapterManager = PointerEventAdapterManager;
//# sourceMappingURL=PointerEventAdapter.js.map